export default __webpack_public_path__ + "4084d7a6934ec21b49417d15a85d7e88.svg";